// inventory list view global components
import { mapActions, mapState } from 'vuex'
import {
    VBtnAction,
    ModelDataTable,
} from '@/components/reusable_components/next'

// inventory list view components
import InventoryToListModel from '@/models/Warehouse/WhInventoryToList'
import TranslatorService from '@/services/translator'
import filters from './filters'
import headers from './headers'

// inventory list view
export default {
    name: 'inventory-list',
    components: {
        ModelDataTable,
        VBtnAction,
    },
    computed: {
        // vuex auth module state
        ...mapState('AuthModule', ['user']),

        // vuex snackbar module state
        ...mapState('SnackbarModalModule', ['responseConfirm']),

        /**
         * @description
         * table component props
         */
        tableProps() {
            return {
                attachParams: {
                    item_number: '1',
                },
                service: InventoryToListModel,
                filters,
                headers,
            }
        },
    },
    data() {
        return {
            dialog: false,
            dialogWait: false,
            selected: null,
        }
    },
    methods: {
        // vuex menues module actions
        ...mapActions('MenuesModule', ['setTitleTopBar', 'setItemsTopBar']),

        // vuex snackbar module actions
        ...mapActions('SnackbarModalModule', [
            'resetSnackbarState',
            'setErrorSnackbar',
            'setSuccessSnackbar',
            'setWarningSnackbar',
        ]),

        /**
         * @description
         * cancelled inventory item action
         */
        cancelled() {
            this.selected
                .cancelled()
                .catch(this.error)
                .then(this.resetSnackbarState)
                .then(this.successCancelled)
                .then(this.refresh)
        },

        /**
         * @description
         * can edit inventory list item flag
         *
         * @param {Object} event
         */
        canEdit(event) {
            return (
                event.item.wh_warehouse_g_branch_office_id ===
                this.user.hr_employee.g_branch_office_id
            )
        },

        /**
         * @description
         * confirm inventory item action
         */
        confirm() {
            this.selected
                .confirm_raw()
                .catch(this.error)
                .then(this.resetSnackbarState)
                .then(this.successConfirm)
                .then(this.refresh)
        },

        /**
         * @description
         * show error snackbar
         *
         * @param error
         */
        error(error) {
            //console.log({ error })
            this.setErrorSnackbar(
                TranslatorService(InventoryToListModel, error.response.data)
            )
        },

        /**
         * @description
         * show pdf
         *
         * @param type
         */
        pdf(type) {
            this.wait(true)
            this.selected.toPdf({ type })
            this.wait()
        },

        /**
         * @description
         * refresh inventory list action
         */
        refresh() {
            this.$refs.table.refresh()
        },

        /**
         * @description
         * remove inventory list item action
         */
        remove() {
            this.selected
                .delete()
                .catch(this.error)
                .then(this.resetSnackbarState)
                .then(this.refresh)
                .then(this.successRemove)
        },

        /**
         * @description
         * route create inventory item action
         */
        submitCreate() {
            this.$router.push({ name: 'inventory-create' })
        },

        /**
         * @description
         * cancelled inventory item submit
         *
         * @param event
         */
        submitCancelled(event) {
            // show cancelled snackbar
            this.setWarningSnackbar({
                title: '¿Deseas cancelar el inventario?',
                message: 'Una vez cancelado no se puede recuperar.',
                confirm: 'cancelar inventario',
            })

            // set selected item
            this.selected = event.item
        },

        /**
         * @description
         * confirm inventory item submit
         *
         * @param event
         */
        submitConfirm(event) {
            // show confirm snackbar
            this.setWarningSnackbar({
                title: '¿Deseas confirmar el inventario?',
                message:
                    'Una vez confirmado no se puede recuperar el stock modificado.',
                confirm: 'confirmar inventario',
            })

            // set selected item
            this.selected = event.item
        },

        /**
         * @description
         * remove inventory item submit
         *
         * @param event
         */
        submitRemove(event) {
            // show remove snackbar
            this.setWarningSnackbar({
                title: '¿Deseas eliminar el inventario?',
                message: 'Una vez eliminado no se puede recuperar.',
                confirm: 'eliminar inventario',
            })

            // set selected item
            this.selected = event.item
        },

        /**
         * @description
         * pdf inventory item submit
         *
         * @param event
         */
        submitPdf(event) {
            // set selected item
            this.selected = event.item

            // show dialog
            this.dialog = true
        },

        /**
         * @description
         * pdf inventory item submit
         *
         * @param event
         */
        submitTake(event) {
            this.$router.push({
                name: 'inventory-take',
                params: {
                    id: event.item.id,
                },
            })
        },

        /**
         * @description
         * pdf inventory item submit
         *
         * @param event
         */
        submitUpdate(event) {
            this.$router.push({
                name: 'inventory-update',
                params: {
                    id: event.item.id,
                },
            })
        },

        /**
         * @description
         * show success cancelled snackbar
         */
        successCancelled() {
            this.setSuccessSnackbar('Inventario cancelado exitosamente.')
        },

        /**
         * @description
         * show success confirm snackbar
         */
        successConfirm() {
            this.setSuccessSnackbar('Inventario confirmado exitosamente.')
        },

        /**
         * @description
         * show success remove snackbar
         */
        successRemove() {
            this.setSuccessSnackbar('Inventario eliminado exitosamente.')
        },

        /**
         * @description
         * set dialog wait
         *
         * @param {Boolean} val
         */
        wait(val = false) {
            this.dialogWait = val
        },
    },
    watch: {
        /**
         *
         */
        async responseConfirm(value) {
            switch (value) {
                case 'cancelar inventario':
                    this.cancelled()
                    break
                case 'confirmar inventario':
                    this.confirm()
                    break
                case 'eliminar inventario':
                    this.remove()
                    break
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_INVENTORY')) ctx.$router.push('/')
        })
    },
    beforeMount() {
        this.setTitleTopBar('Inventarios')
        this.setItemsTopBar([
            {
                action: this.submitCreate,
                color: 'accent',
                icon: 'add_circle',
                text: 'crear inventario',
                tip: 'Crear nuevo inventario',
                can: 'CREATE_INVENTORY',
            },
        ])
    },
}
